module.exports = __webpack_public_path__ + "img/upload.0b1ad761.svg";